<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" :max-width="steps[step].width" :fullscreen="$vuetify.breakpoint.xsOnly && steps[step].fullscreen")

      v-card(flat)
        v-card-title.px-0(v-if="steps[step].title")
          v-row.px-5(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="closeDialog()" height)
                eva-icon(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.primary500--text {{$t('setup_yezza')}}
          v-progress-linear.mt-2(v-if="!isLastStep" color="primary500" background-color="basic300" height=4 :value="currentProgress")
        v-card-text
          v-window(v-model="step" touchless)
            v-window-item(:value="0")
              v-container
                .h6.primary500--text.mt-6 {{$t('fulfill_order')}}
                .p1.primary500--text.mt-2 {{$t('please_note')}}
                a.p1.textColorAccent--text.text-decoration-none.mt-2(href="https://help.yezza.com/hc/en-my/articles/4412895578265-What-is-Yezza-Shipping-" target="_blank") {{$t('learn_more')}}
            
            v-window-item(:value="1")
              v-container
                .h6.primary500--text {{$t('how_to_fulfill_order')}}
                .p1.primary500--text.mt-2 {{$t('select_all')}}

                div.pa-4.mt-4.clickable(v-for="fullfillment in cFullfillmentList" flat :style="fullfillments.includes(fullfillment.id)? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="updateFulfilment(fullfillment.id)" :key="fullfillment.id")
                  .s1 {{ fullfillment.title }}
                  .c1.basic600--text {{ fullfillment.description }}
            
            v-window-item(:value="2")
              v-container
                .s1.primary500--text {{$t('your_location')}}
                .p2.primary500--text.mt-2 {{$t('where_courier_collect')}}

                v-form(ref="form")
                  v-card.pa-4.mb-6.mt-4(outlined flat)
                    .address.mt-4
                      address-inputs-id(v-if="isIndoAddress" :parentAddress.sync="address")
                      address-inputs(v-else :parentAddress.sync="address" :autofillPostcode="true")
                    .company-phone
                      div.label.basic600--text.text-uppercase {{$t('phone.label')}}
                      v-text-field.mt-2(v-model='address.phone' :placeholder="$t('phone.placeholder')" dense outlined height="40" type="tel" background-color="basic200" :rules="rules.not_empty")
                  
                  y-checkbox.my-auto.mx-0.pa-0(v-if="fullfillments.length > 1 && fullfillments.includes('pickup')" v-model="sameLocation" :color="$vuetify.theme.themes[$theme].textColorAccent")
                    template(v-slot:label)
                      .p1.my-auto {{$t('same_location_store_pickup')}}
                  
                  .pickup-address(v-if="!sameLocation")
                    .s1.mt-4 {{$t('store_pickup_address')}}
                    v-card.pa-4.mb-6.mt-4(outlined flat)
                      .address.mt-4
                        address-inputs-id(v-if="isIndoAddress" :parentAddress.sync="pickupAddress")
                        address-inputs(v-else :parentAddress.sync="pickupAddress" :autofillPostcode="true")
                      .company-phone
                        div.label.basic600--text.text-uppercase {{$t('phone.label')}}
                        v-text-field.mt-2(v-model='pickupAddress.phone' :placeholder="$t('phone.placeholder')" dense outlined height="40" type="tel" background-color="basic200" :rules="rules.not_empty")

            v-window-item(:value="3")
              v-container
                .s1.primary500--text.mt-2 {{$t('location_coordinate')}}
                .p2.primary500--text.mt-2 {{$t('drag_pin_point')}}

                v-card.pa-4.mb-6.mt-4(outlined flat)
                  .latlng
                    gmap-map(:zoom="16" :center="{lat:coordinate.lat, lng:coordinate.lng}" :options="{streetViewControl:false}" style="width:100%; height:400px;")
                      gmap-marker(:draggable="true" :position="{lat:coordinate.lat, lng: coordinate.lng}" @dragend="updateCoordinate")

            v-window-item(:value="4")
              v-container
                .s2.basic600--text.text-uppercase {{$t('courier_shipping')}}
                .s1.primary500--text.mt-2 {{$t('courier_services')}}
                .p2.primary500--text.mt-2 {{$t('courier_option')}}

                template(v-if="courier")
                  div.pa-4.mt-4.clickable(v-if="!courier.required_dropoff_point" v-for="courier in courier.shipping_const" flat :style="courierObject(courier).enabled? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : courierObject(courier).out_of_service ? 'border:1px solid var(--v-basic400); background: var(--v-basic200); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="courierObject(courier).out_of_service ? '' : onUpdateCourier(courierObject(courier))" :key="courier.id")
                    .s1(:class="courierObject(courier).out_of_service ? 'basic600--text' : 'primary500--text' ") {{ courier.name }}
                    .c1.basic600--text(v-if="courierObject(courier).out_of_service") {{$t('courier_not_available')}}
                
                template(v-if="courier && courier.channel === 'ys_malaysia'")
                  .p2.mt-6 {{$t('select_prefered_method')}}
                  v-row
                    v-col(v-for="handover in handoverList" :key="handover.id" align="center")
                      div.pa-3.mt-4.clickable(flat :style="(selectedHandover && selectedHandover === handover.id)? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:2px solid var(--v-basic300); border-radius: 4px;'" @click="selectedHandover = handover.id")
                        .div.py-5
                          eva-icon(:name="handover.icon" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
                          .s1 {{ handover.title }}

            v-window-item(:value="5")
              v-container
                .s2.basic600--text.text-uppercase {{$t('local_delivery')}}
                .s1.primary500--text.mt-2 {{$t('choose_local_delivery')}}
                .p2.primary500--text.mt-2 {{$t('local_delivery_option')}}
                template(v-if="localDelivery")
                  div.pa-4.mt-4.clickable(v-for="localdelivery in localDelivery.shipping_const" flat :style="localDeliveryObject(localdelivery).enabled? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : localDeliveryObject(localdelivery).out_of_service ? 'border:1px solid var(--v-basic400); background: var(--v-basic200); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="localDeliveryObject(localdelivery).out_of_service ? '' : onUpdateLocalDelivery(localDeliveryObject(localdelivery))" :key="localdelivery.id")
                    .s1(:class="localDeliveryObject(localdelivery).out_of_service ? 'basic600--text' : 'primary500--text' ") {{ localdelivery.name }}
                    .c1.basic600--text(v-if="localDeliveryObject(localdelivery).out_of_service") {{$t('courier_not_available')}}
                
                template(v-if="localDelivery && localDelivery.channel === 'ys_malaysia'")
                  .p2.mt-6 {{$t('select_vehicles')}}
                  v-row
                    v-col(v-for="vehicle in vehicleList" :key="vehicle.id" align="center")
                      div.pa-3.mt-4.clickable(flat :style="(selectedVehicle && selectedVehicle === vehicle.id)? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:2px solid var(--v-basic300); border-radius: 4px;'" @click="selectedVehicle = vehicle.id")
                        .div.py-5
                          v-icon(:color="$vuetify.theme.themes[$theme].primary500" width="24" height="24") {{ vehicle.icon }}
                          .s1.mt-3 {{ vehicle.title }}

            v-window-item(:value="6")
              v-container
                .s1.primary500--text.mt-2 {{$t('keep_shipping_zone')}}
                .p2.primary500--text.mt-2 {{$t('shipping_zone_necessary')}}
                  div.d-flex
                    div.mx-1(style="font-size:8px;") ●
                    .p2 {{$t('organize_manual_rates')}}
                  div.d-flex
                    div.mx-1(style="font-size:8px;") ●
                    .p2 {{$t('provide_COD_option')}}
                  div.d-flex
                    div.mx-1(style="font-size:8px;") ●
                    .p2 {{$t('hire_own_rider')}}

                div.pa-4.mt-4.clickable(flat :style="keepShippingZones? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="keepShippingZones = true")
                  .s1 {{$t('keep_shipping_zone_yes')}}
                  .c1.basic600--text {{$t('keep_shipping_zone_yes_desc')}}
                
                div.pa-4.mt-4.clickable(flat :style="!keepShippingZones? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="keepShippingZones = false")
                  .s1 {{$t('keep_shipping_zone_no')}}
                  .c1.basic600--text {{$t('keep_shipping_zone_no_desc')}}
                
                .s1.primary500--text.mt-8 {{$t('what_are_yezza_shipping_rates')}}
                .p2.primary500--text.mt-2 {{$t('get_real_time_rates')}}
          
            v-window-item(:value="7")
              v-form(ref="form")
                v-container
                  .s2.basic600--text.text-uppercase {{$t('courier_shipping_rates')}}
                  .s1.primary500--text.mt-2 {{$t('markup_courier_shipping_rates')}}
                  .p2.primary500--text.mt-2 {{$t('markup_courier_shipping_rates_desc1')}}
                  .c1.basic600--text.mt-3 {{$t('markup_courier_shipping_rates_desc2')}}
                    div.ml-13
                      .c1.basic600--text {{$t('markup_courier_shipping_rates_time')}}
                      .c1.basic600--text {{$t('markup_courier_shipping_rates_fee_charge')}}

                  div.pa-4.mt-4.clickable(flat :style="courierRate.markup.value ? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="courierRate.markup.value = true")
                    .s1 {{$t('yes')}}
                  
                  div.pa-4.mt-4.clickable(flat :style="courierRate.markup.value !== null && !courierRate.markup.value? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="courierRate.markup.value = false")
                    .s1 {{$t('no')}}

                  .markup.mt-4(v-if="courierRate.markup.value")
                    div.text-center
                      .label.basic600--text.text-uppercase {{$t('markup_amount')}}
                      div.d-flex
                        div.mx-auto(style="max-width:140px")
                          v-text-field.mt-2(v-model='courierRate.markup.amount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                      .c1.basic600--text.mt-2 {{$t('markup_amount_desc')}}
                  
                  .s1.primary500--text.mt-8 {{$t('offer_free_shipping')}}
                  .p2.primary500--text.mt-2 {{$t('offer_free_shipping_desc')}}

                  div.pa-4.mt-4.clickable(flat :style="courierRate.free_shipping.value ? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="courierRate.free_shipping.value = true")
                    .s1 {{$t('yes')}}
                  
                  div.pa-4.mt-4.clickable(flat :style="courierRate.free_shipping.value !== null && !courierRate.free_shipping.value? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="courierRate.free_shipping.value = false")
                    .s1 {{$t('maybe_later')}}

                  .free-shipping.mt-4(v-if="courierRate.free_shipping.value")
                    div.text-center
                      .label.basic600--text.text-uppercase {{$t('offer_free_shipping_min_order')}}
                      div.d-flex
                        div.mx-auto(style="max-width:140px")
                          v-text-field.mt-2(v-model='courierRate.free_shipping.amount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                      .c1.basic600--text.mt-2 {{$t('offer_free_shipping_min_order_desc')}}
            
            v-window-item(:value="8")
              v-form(ref="form")
                v-container
                  .s2.basic600--text.text-uppercase {{$t('local_delivery_rates')}}
                  .s1.primary500--text.mt-2 {{$t('local_delivery_rates_markup')}}
                  .p2.primary500--text.mt-2 {{$t('local_delivery_rates_markup_desc1')}}
                  .c1.basic600--text.mt-3 {{$t('local_delivery_rates_markup_desc2')}}
                    div.ml-13
                      .c1.basic600--text {{$t('local_delivery_rates_markup_time')}}
                      .c1.basic600--text {{$t('local_delivery_rates_markup_fee_charge')}}

                  div.pa-4.mt-4.clickable(flat :style="localDeliveryRate.markup.value ? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="localDeliveryRate.markup.value = true")
                    .s1 {{$t('yes')}}
                  
                  div.pa-4.mt-4.clickable(flat :style="localDeliveryRate.markup.value !== null && !localDeliveryRate.markup.value? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="localDeliveryRate.markup.value = false")
                    .s1 {{$t('no')}}

                  .markup.mt-4(v-if="localDeliveryRate.markup.value")
                    div.text-center
                      .label.basic600--text.text-uppercase {{$t('markup_amount')}}
                      div.d-flex
                        div.mx-auto(style="max-width:140px")
                          v-text-field.mt-2(v-model='localDeliveryRate.markup.amount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                      .c1.basic600--text.mt-2 {{$t('markup_amount_desc')}}
                  
                  .s1.primary500--text.mt-8 {{$t('offer_free_shipping')}}
                  .p2.primary500--text.mt-2 {{$t('offer_free_shipping_desc')}}

                  div.pa-4.mt-4.clickable(flat :style="localDeliveryRate.free_shipping.value ? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="localDeliveryRate.free_shipping.value = true")
                    .s1 {{$t('yes')}}
                  
                  div.pa-4.mt-4.clickable(flat :style="localDeliveryRate.free_shipping.value !== null && !localDeliveryRate.free_shipping.value? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="localDeliveryRate.free_shipping.value = false")
                    .s1 {{$t('maybe_later')}}

                  .free-shipping.mt-4(v-if="localDeliveryRate.free_shipping.value")
                    div.text-center
                      .label.basic600--text.text-uppercase {{$t('offer_free_shipping_min_order')}}
                      div.d-flex
                        div.mx-auto(style="max-width:140px")
                          v-text-field.mt-2(v-model='localDeliveryRate.free_shipping.amount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                      .c1.basic600--text.mt-2 {{$t('offer_free_shipping_min_order_desc')}}
            
            v-window-item(:value="9")
              v-form(ref="form")
                v-container
                  .s2.basic600--text.text-uppercase {{$t('store_pickup')}}
                  .s1.primary500--text.mt-2 {{$t('store_pickup_desc1')}}
                  .p2.primary500--text.mt-2 {{$t('store_pickup_desc2')}}

                  v-card.pa-4.mt-4(flat style="border:1px solid var(--v-basic300);")
                    .s1 {{$t('store_pickup_instruction')}}
                    div.d-flex
                      v-spacer
                      .c1.basic600--text.mr-1(v-if="pickupSettings.instruction") {{ pickupSettings.instruction.length }}/300
                    v-textarea.mt-2(v-model='pickupSettings.instruction' placeholder="e.g. Where to go in the store, what information you will need etc" outlined dense persistent-hint background-color="basic200" :rules="rules.instructions_count" hide-details="auto")
                  
                  .s1.primary500--text.mt-8 {{$t('store_pickup_can_pay')}}
                  .p2.primary500--text.mt-2 {{$t('store_pickup_can_pay_desc')}}

                  div.pa-4.mt-4.clickable(flat :style="pickupSettings.pas ? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="pickupSettings.pas = true")
                    .s1 {{$t('yes')}}
                  
                  div.pa-4.mt-4.clickable(flat :style="pickupSettings.pas !== null && !pickupSettings.pas? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="pickupSettings.pas = false")
                    .s1 {{$t('no')}}
          
            v-window-item(:value="10")
              v-container
                .header.text-center
                  div.d-flex
                    v-img.mx-auto(:src="require('@/assets/images/setup_success.png')" max-width="88" width="196px" height="148px")
                  .h5.mt-4 {{$t('great_all_set')}}
                  .p1.mt-4(v-if="fullfillments.includes('courier') && fullfillments.includes('local_delivery')") {{$t('finish_yezza_store_setup_desc1')}}
                  .p1.mt-4(v-else-if="fullfillments.includes('courier')") {{$t('finish_yezza_store_setup_desc2')}}
                  .p1.mt-4(v-else-if="fullfillments.includes('local_delivery')") {{$t('finish_yezza_store_setup_desc3')}}
                  .p1.mt-4(v-else) {{$t('finish_yezza_store_setup_desc4')}}
                
                v-card.pa-4.mt-4(v-if="fullfillments.includes('courier') || fullfillments.includes('local_delivery')" flat style="border:1px solid var(--v-basic300);")
                  .p2.basic600--text {{$t('finish_yezza_store_setup_desc5')}}
                  .p2.basic600--text {{$t('finish_yezza_store_setup_desc6')}}
                  .p2.basic600--text {{$t('finish_yezza_store_setup_desc7')}}
                  .p2.basic600--text {{$t('finish_yezza_store_setup_desc8')}}
                
                div.text-center.my-6
                  v-btn.mr-2(color="info500" dark @click="closeDialog()" depressed height=32)
                    .button-AA-small.basic100--text {{$t('return_to_shipping')}}
                
        
        v-card-actions.pa-4(v-if="!isLastStep")
          v-spacer
          v-btn(color="white" text @click="previousStep()" depressed height=32)
            .button-Aa-small.primary400--text {{ steps[step].secondaryButton }}
          v-btn.mr-2(color="info500" @click="nextStep()" depressed height=32 :disabled="!canProceed" :loading="isLoading")
            .button-AA-small.basic100--text {{ steps[step].primaryButton }}
    
    .modals
      y-dialog(v-model="showAbandonDialog" persistent width="340")
        v-card
          v-card-title(style="height:56px;")
            .h6.basic800--text {{$t('leaving_yezza_shipping_setup')}}
          v-card-text
            .p2.primary400--text {{$t('progress_is_saved')}}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click="closeDialog()")
              .button-Aa-small.primary400--text {{$t('exit')}}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="showAbandonDialog = false")
              .button-AA-small.basic100--text {{$t('keep_working')}}

</template>

<script>
import { mapGetters } from 'vuex'
import Vue from "vue"
import * as VueGoogleMaps from "vue2-google-maps"
import AddressInputs from '@/components/AddressInputs.vue'
import AddressInputsId from '@/components/AddressInputsId.vue'

Vue.use(VueGoogleMaps,{
  load:{ key: process.env.VUE_APP_GOOGLEMAP_API_KEY }
})
export default {
  name: 'WalkThroughShipping',
  props: ['open', 'company', 'parentFullfilments'],
  components: { AddressInputs, AddressInputsId },
  data: (vm) => ({
    stepIndex: 0,
    isLoading: false,
    showAbandonDialog: false,
    steps: [
      { title: false, fullscreen: false, width: '400px', secondaryButton: 'Maybe later', primaryButton: 'Setup Now'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Cancel', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Next'},
      { title: true, fullscreen: true, width: '600px', secondaryButton: 'Back', primaryButton: 'Finish'},
      { title: 'Congratulations!', fullscreen: false, width: '600px',}
    ],
    zones: [],
    fullfillments: [],
    fullfillmentList: [
      { id: 'courier', title: vm.$t('courier_shipping_title'), description: vm.$t('courier_shipping_title_desc')},
      { id: 'local_delivery', title: vm.$t('local_delivery_title'), description: vm.$t('local_delivery_title_desc')},
      { id: 'pickup', title: vm.$t('pickup_title'), description: vm.$t('pickup_title_desc')},
    ],
    address: {},
    pickupAddress: {},
    coordinate: {
      lat: 3.152815,
      lng: 101.703651,
    },
    isFetchingAddress: false,
    sameLocation: true,
    courier: null,
    selectedHandover: null,
    handoverList: [
      { id: 'pickup', title: 'Courier pick up', icon: 'car-outline'},
      { id: 'dropoff', title: 'Self drop-off', icon: 'inbox-outline'},
    ],
    localDelivery: null,
    selectedVehicle: null,
    vehicleList: [
      { id: 'motorcycle', title: 'Motorcycle', icon: 'mdi-moped-outline'},
      { id: 'car', title: 'Car', icon: 'mdi-car-side'},
    ],
    keepShippingZones: true,
    courierRate: {
      markup: {
        value: null,
        amount: null
      },
      free_shipping: {
        value: null,
        amount: null
      }
    },
    localDeliveryRate: {
      markup: {
        value: null,
        amount: null
      },
      free_shipping: {
        value: null,
        amount: null
      }
    },
    pickup: null,
    pickupSettings: {
      instruction: '',
      pas: null,
    },
    externalCourierUpdated: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      instructions_count: [(v) => !!v || 'This field is required', v => (v || '').length <= 300 || 'Max 300 characters']
    }
  }),
  computed: {
    ...mapGetters({
      shipments: 'orders/getShipments'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    cFullfillmentList () {
      return this.fullfillmentList.filter(f => this.parentFullfilments.includes(f.id))
    },
    currentSteps () {
      let steps = [0, 1, 2]
      if (this.cFullfillmentList.length === 1) {
        steps = [2]
      }
      if (this.fullfillments.includes('local_delivery')) {
        steps.push(3)
      }
      if (this.fullfillments.includes('courier')) {
        steps.push(4)
      }
      if (this.fullfillments.includes('local_delivery')) {
        steps.push(5)
      }
      if (this.zones.length === 1 && this.zones[0].name === '1 Malaysia') {
        /**/
      } else if (this.fullfillments.includes('courier') || this.fullfillments.includes('local_delivery')) {
        steps.push(6)
      }
      if (this.fullfillments.includes('courier')) {
        steps.push(7)
      }
      if (this.fullfillments.includes('local_delivery')) {
        steps.push(8)
      }
      if (this.fullfillments.includes('pickup')) {
        steps.push(9)
      }
      steps.push(10)
      return steps
    },
    step () {
      return this.currentSteps[this.stepIndex]
    },
    currentProgress () {
      return Math.ceil((this.step / this.currentSteps.length) * 100)
    },
    isLastStep () {
      if (this.currentSteps.length - 1 === this.stepIndex) {
        return true
      }
      return false
    },
    canProceed () {
      let value = true
      switch (this.step) {
        case 1: {
          if (this.fullfillments.length === 0) {
            return false
          }
          break
        }
        case 4: {
          if (this.courier.available_shipping.filter(f => f.enabled).length === 0) {
            return false
          }
          if (this.courier.channel === 'ys_malaysia' && !this.selectedHandover) {
            return false
          }
          break
        }
        case 5: {
          if (this.localDelivery.available_shipping.filter(f => f.enabled).length === 0) {
            return false
          }
          if (this.localDelivery.channel === 'ys_malaysia' && !this.selectedVehicle) {
            return false
          }
          break
        }
        case 7: {
          if (this.courierRate.markup.value === null) {
            return false
          }
          if (this.courierRate.free_shipping.value === null) {
            return false
          }
          break
        }
        case 8: {
          if (this.localDeliveryRate.markup.value === null) {
            return false
          }
          if (this.localDeliveryRate.free_shipping.value === null) {
            return false
          }
          break
        }
        case 9: {
          if (this.pickupSettings.pas === null) {
            return false
          }
          break
        }
      }
      return value
    },
    isIndoAddress () {
      if (this.$currency.code === 'IDR') {
        return true
      }
      return false
    }
  },
  watch: {
    selectedHandover (val) {
      if (this.courier.available_shipping.filter(f => f.enabled).length === 0) {
        return
      }
      this.courier.selected_shipping = this.courier.available_shipping.filter(f => f.enabled).map(item => { return {
        ...item,
        service_type: val
      }})
    },
    courierRate: {
      deep: true,
      handler (rate) {
        if (rate.markup.value) {
          this.courier.custom_rates_enabled = true
          this.courier.markup_rate = parseInt((parseFloat(rate.markup.amount)).toFixed(this.$currency.exponent).replace('.', ''))
        } else {
          this.courier.custom_rates_enabled = false
          this.courier.markup_rate = null
        }
        if (rate.free_shipping.value) {
          this.courier.free_shipping_enabled = true
          this.courier.free_shipping = parseInt((parseFloat(rate.free_shipping.amount)).toFixed(this.$currency.exponent).replace('.', ''))
        } else {
          this.courier.free_shipping_enabled = false
          this.courier.free_shipping = null
        }
      }
    },
    localDeliveryRate: {
      deep: true,
      handler (rate) {
        if (rate.markup.value) {
          this.localDelivery.custom_rates_enabled = true
          this.localDelivery.markup_rate = parseInt((parseFloat(rate.markup.amount)).toFixed(this.$currency.exponent).replace('.', ''))
        } else {
          this.localDelivery.custom_rates_enabled = false
          this.localDelivery.markup_rate = null
        }
        if (rate.free_shipping.value) {
          this.localDelivery.free_shipping_enabled = true
          this.localDelivery.free_shipping = parseInt((parseFloat(rate.free_shipping.amount)).toFixed(this.$currency.exponent).replace('.', ''))
        } else {
          this.localDelivery.free_shipping_enabled = false
          this.localDelivery.free_shipping = null
        }
      }
    },
    pickupSettings: {
      deep: true,
      handler (settings) {
        if (settings.pas) {
          this.pickup.pay_at_shop = true
        } else {
          this.pickup.pay_at_shop = false
        }
        this.pickup.instruction = settings.instruction
      }
    }
  },
  mounted () {
    this.fetchShippingZones()
    if (this.parentFullfilments.length === 1) {
      this.fullfillments = this.parentFullfilments
    }
  },
  methods: {
    fetchShippingZones () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/zones?page=1&page_size=100`)
        .then((response) => {
          this.zones = response.data.results
        })
        .catch(() => {})
    },
    async fetchShippingCourier() {
      if (this.fullfillments.includes('courier')) {
        try {
          const resp = await this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/courier`)
          this.courier = { ...resp.data }
          this.courier.enabled = true
        } catch {/**/}
      }
      if (this.fullfillments.includes('local_delivery')) {
        try {
          const resp = await this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery`)
          this.localDelivery = { ...resp.data }
          this.localDelivery.enabled = true
        } catch {/**/}
      }
      if (this.fullfillments.includes('pickup')) {
        try {
          const resp = await this.$axios.get(`/shipping/settings/${this.company.slug}/storepickup`)
          this.pickup = { ...resp.data }
          this.pickup.enabled = true
        } catch {/**/}
      }
    },
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isFetchingAddress = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.address.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.address, 'city', addresses[0].city)
          this.$set(this.address, 'state', addresses[0].state)
          this.$set(this.address, 'country', addresses[0].country)
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isFetchingAddress = false
      })
    },
    fetchPostcodes2 (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isFetchingAddress = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.pickupAddress.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.pickupAddress, 'city', addresses[0].city)
          this.$set(this.pickupAddress, 'state', addresses[0].state)
          this.$set(this.pickupAddress, 'country', addresses[0].country)
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isFetchingAddress = false
      })
    },
    closeDialog () {
      this.showModal = !this.showModal
    },
    previousStep () {
      if (this.stepIndex === 0) {
        this.showModal = false
        return
      } else if (this.step === 2) {
        this.showAbandonDialog = true
        return
      }
      this.stepIndex--
    },
    async nextStep () {
      if (this.step === 2) {
        if (!this.$refs.form.validate()) {
          return
        }
        this.isLoading = true
        await this.updateCourierAddress()
        await this.fetchShippingCourier()
        this.$emit('finished')
      } else if (this.step === 3) {
        this.isLoading = true
        await this.updateLocalDeliveryAddress()
      } else if (this.step === 4) {
        this.isLoading = true
        await this.updateCourierSettings()
      } else if (this.step === 5) {
        this.isLoading = true
        await this.updateLocalDeliverySettings()
      } else if (this.step === 7) {
        if (!this.$refs.form.validate()) {
          return
        }
        this.isLoading = true
        await this.updateCourierSettings()
      } else if (this.step === 8) {
        if (!this.$refs.form.validate()) {
          return
        }
        this.isLoading = true
        await this.updateLocalDeliverySettings()
      } else if (this.step === 9) {
        if (!this.$refs.form.validate()) {
          return
        }
        this.isLoading = true
        await this.updatePickupSettings()
      }
      if (this.currentSteps.length - 2 === this.stepIndex) {
        this.updateZoneSettings()
      }
      this.isLoading = false
      this.stepIndex++
    },
    updateFulfilment (type) {
      if (this.fullfillments.includes(type)) {
        this.fullfillments = this.fullfillments.filter(item => item !== type)
      } else {
        this.fullfillments.push(type)
      }
    },
    updateCoordinate(location){
      this.coordinate.lat = location.latLng.lat()
      this.coordinate.lng = location.latLng.lng()
    },
    async updateCourierAddress() {
      if (this.fullfillments.includes('courier')) {
        try {
          const params = {
            pickup_address: this.address
          }
          await this.axios.post(`/shipping/yezzashipping/settings/${this.company.slug}/courier/`, params)
        } catch {/**/}
      }
      if (this.fullfillments.includes('local_delivery')) {
        try {
          const params = {
            pickup_address: this.address
          }
          const resp = await this.axios.post(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery/`, params)
          const address = resp.data.pickup_address
          this.coordinate.lat = address.lat
          this.coordinate.lng = address.lng
        } catch {/**/}
      }
      if (this.fullfillments.includes('pickup')) {
        try {
          const params = {
            pickup_address: this.sameLocation ? this.address : this.pickupAddress
          }
          await this.axios.post(`/shipping/settings/${this.company.slug}/storepickup/`, params)
        } catch {/**/}
      }
    },
    async updateLocalDeliveryAddress() {
      try {
        const params = {
          pickup_address: this.address
        }
        params.pickup_address.lat = this.coordinate.lat
        params.pickup_address.lng = this.coordinate.lng
        if (this.localDelivery) {
          await this.axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery/${this.localDelivery.id}`, params)
        } else {
          await this.axios.post(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery/`, params)
        }
      } catch {/**/}
    },
    async updateCourierSettings () {
      try {
        await this.$axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/courier/${this.courier.id}`, this.courier)
        this.updateExternalCourier()
      } catch {/**/}
      this.$emit('finished')
    },
    async updateLocalDeliverySettings () {
      try {
        await this.$axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery/${this.localDelivery.id}`, this.localDelivery)
        this.updateExternalCourier()
      } catch {/**/}
      this.$emit('finished')
    },
    async updatePickupSettings () {
      try {
        await this.$axios.post(`/shipping/settings/${this.company.slug}/storepickup/`, this.pickup)
        this.updateExternalCourier()
      } catch {/**/}
      this.$emit('finished')
    },
    onUpdateCourier (shipping) {
      let selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
      if (this.courier.channel === 'ys_malaysia') {
        let selectedShipping = selectedShippings.find(f => f.title === shipping.title)
        if (selectedShipping) {
          this.courier.available_shipping.filter(f => f.title === shipping.title).forEach(o => {
            this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
          })
        } else {
          this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === shipping.service_id)], 'enabled', true)
        }
      } else {
        let selectedShipping = selectedShippings.filter(f => f.title === shipping.title)
        this.courier.available_shipping.filter(f => f.title === shipping.title).forEach(o => {
          if (selectedShipping.length > 0) {
            this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
          } else {
            this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', true)
          }
        })
      }
      this.courier.selected_shipping = this.courier.available_shipping.filter(f => f.enabled)
    },
    courierObject(courier) {
      let selectedShippings = []
      let shippings = []
      if (this.courier) {
        selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
        shippings = this.courier.available_shipping
      }
      let shipping = shippings.filter(f => f.title === courier.name)
      const choices = shippings.filter(f => f.title === courier.name)
      if (shipping.length > 1) {
        const dropoff = shipping.filter(f => f.service_type === 'dropoff')
        if (dropoff.length > 0) {
          shipping = dropoff[0]
        } else {
          shipping = shipping[0]
        }
      } else {
        shipping = shipping[0]
      }
      let selectedShipping = selectedShippings.filter(f => f.title === courier.name)
      let isSelected = selectedShipping.length > 0

      if (!shipping) {
        return { out_of_service: true, enabled: isSelected }
      }
      let isPrefered = this.courier.preferred ===  shipping.service_id
      let data = {
        ...shipping,
        name: courier.name,
        enabled: isSelected,
        preferred: isPrefered,
        choices: choices,
        data: shipping,
        required_dropoff_point: courier.required_dropoff_point
      }
      return data
    },
    onUpdateLocalDelivery (shipping) {
      let selectedShippings = this.localDelivery.available_shipping.filter(f => f.enabled)
      let selectedShipping = selectedShippings.filter(f => f.title === shipping.name)
      this.localDelivery.available_shipping.filter(f => f.title === shipping.name).forEach(o => {
        if (selectedShipping.length > 0) {
          this.$set(this.localDelivery.available_shipping[this.localDelivery.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
        } else {
          this.$set(this.localDelivery.available_shipping[this.localDelivery.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', true)
        }
      })
      this.localDelivery.selected_shipping = this.localDelivery.available_shipping.filter(f => f.enabled)
    },
    localDeliveryObject(localdelivery) {
      let selectedShippings = []
      let shippings = []
      if (Object.keys(this.localDelivery).length > 0) {
        selectedShippings = this.localDelivery.available_shipping.filter(f => f.enabled)
        shippings = this.localDelivery.available_shipping
      }
      let shipping = shippings.find(f => f.title === localdelivery.name)
      const choices = shippings.filter(f => f.title === localdelivery.name)
      let selectedShipping = selectedShippings.filter(f => f.title === localdelivery.name)
      let isSelected = selectedShipping.length > 0

      if (!shipping) {
        return { out_of_service: true, enabled: isSelected }
      }
      let isPrefered = this.localDelivery.preferred ===  shipping.service_id
      return {...shipping, name: localdelivery.name, ref_id: localdelivery.id, enabled: isSelected, preferred: isPrefered, choices: choices, data: shipping }
    },
    updateZoneSettings () {
      const shippingMethods = []
      if (this.fullfillments.includes('courier')) {
        shippingMethods.push("ys_courier")
      }
      if (this.fullfillments.includes('local_delivery')) {
        shippingMethods.push("ys_localdelivery")
      }
      if (this.fullfillments.includes('pickup')) {
        shippingMethods.push("pickup")
      }
      if (this.zones.length === 1 && this.zones[0].name === '1 Malaysia') {
        const params = { ...this.zones[0] }
        params.enabled = true
        params.shipping_methods = shippingMethods
        this.upateShippingZone(params)
      } else if (this.zones.length > 0) {
        const hasEnabledZone = this.zones.filter(f => f.enabled).length > 0
        if (hasEnabledZone) {
          this.zones.forEach(params => {
            let methods = params.shipping_methods.concat(shippingMethods)
            if (!this.keepShippingZones) {
              methods = methods.filter(method => method !== 'manual')
            }
            params.shipping_methods = methods
            this.upateShippingZone(params)
          })
        } else {
          const params = {
            enabled: true,
            name : '1 Malaysia',
            shipping_methods: shippingMethods
          }
          this.$axios.post(`/shipping/settings/${this.company.slug}/zones/`, params)
            .catch(() => {})
        }
      }
    },
    updateExternalCourier() {
      if (this.externalCourierUpdated) {
        return
      }
      if (this.shipments.easyparcel) { this.axios.patch(`/shipping/settings/${this.company.slug}/easyparcel`, {enabled: false}).catch(() => {}) }
      if (this.shipments.lalamove) { this.axios.patch(`/shipping/settings/${this.company.slug}/lalamove`, {enabled: false}).catch(() => {}) }
      if (this.shipments.zepto) { this.axios.patch(`/shipping/settings/${this.company.slug}/zepto`, {enabled: false}).catch(() => {}) }
      this.externalCourierUpdated = true
    },
    upateShippingZone (params) {
      this.$axios.put(`/shipping/settings/${this.company.slug}/zones/${params.id}/`, params)
        .catch(() => {})
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "update_company": "Update company details",
    "company_logo": "Company logo",
    "company_name": {
      "label": "Company Name",
      "placeholder": "Write your company name here"
    },
    "phone": {
      "label": "Phone number",
      "placeholder": "Enter phone number"
    },
    "registration_number": {
      "label": "Company Registration No",
      "placeholder": "Write your company registration number here"
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    },
    "tax_rate": {
      "label": "Tax rate",
      "placeholder": "Default tax rate for price calculation"
    },
    "cancel": "Cancel",
    "update": "Update",
    "setup_yezza" : "Setup Yezza Shipping",
    "fulfill_order" : "Fulfill orders end-to-end without ever leaving Yezza",
    "please_note" : "Please note that by activating Yezza Shipping, all shipping integrations  (EasyParcel, Lalamove, ZeptoExpress) will be automatically disabled.",
                            
    "how_to_fulfill_order":"How do you fulfill your orders?",
    "select_all":"Select all that apply.",

    "your_location" : "Where is your location?",
    "where_courier_collect":"This is where courier services will go to collect your packages for delivery.",

    "same_location_store_pickup":"Same location for store pickup",
                  
    "store_pickup_address":"Store pick up address",
    "location_coordinate":"Where is your location's coordinate?",
    "drag_pin_point":"Drag pinpoint icon 📍to adjust your location",

    "courier_shipping":"COURIER SHIPPING",
    "courier_services":"Which courier services will you use?",
    "courier_option":"These are the courier options you will have to arrange shipments. Select all that apply.",

    "courier_not_available":"Not available in your area",
                
    "select_prefered_method":"Select prefered handover method:",
    "local_delivery":"LOCAL DELIVERY",
    "choose_local_delivery":"Which local delivery services will you use?",
    "local_delivery_option":"These are the on-demand delivery options you will have to arrange shipments. Select all that apply.",

    "select_vehicles":"Select vehicle(s) you will use:",
    "keep_shipping_zone":"Do you want to keep your shipping zones?",
    "shipping_zone_necessary":"Shipping zones are necessary if you:",
    "organize_manual_rates":"Need to organize manual rates by delivery area",
    "provide_COD_option":"Want to provide customers with COD payment option",
    "hire_own_rider":"Hire your own rider with specified rates",

    "keep_shipping_zone_yes":"Yes, keep my shipping zones",
    "keep_shipping_zone_yes_desc":"We’ll replace any shipping integrations with Yezza Shipping. No changes will be made to your Manual Delivery rates.",
                
    "keep_shipping_zone_no":"No, I don’t need shipping zones",
    "keep_shipping_zone_no_desc":"Shipping rates at customer checkout will be auto-calculated by Yezza Shipping.",
                
    "what_are_yezza_shipping_rates":"What are Yezza Shipping rates?",
    "get_real_time_rates":"Your customers will get real-time calculated rates from our delivery partners at checkout based on recipient address and package weight. You can even markup these prices to cover any extra costs.",
          
    "courier_shipping_rates":"COURIER SHIPPING RATES",
    "markup_courier_shipping_rates":"Do you want to mark up Yezza Shipping rates for courier shipping orders?",
    "markup_courier_shipping_rates_desc1":"Charge customers additional markup amounts on top of Yezza Shipping rates.",
    "markup_courier_shipping_rates_desc2":"Example: Markup amount = RM 4.00",
    "markup_courier_shipping_rates_time":"time rates = RM 5.00",
    "markup_courier_shipping_rates_fee_charge":"fee charge = RM 12.00",

                  
    "markup_amount":"markup amount:",
    "markup_amount_desc":"This amount will be added to calculated real-time rate",
                  
    "offer_free_shipping":"Would you like to offer customers free shipping?",
    "offer_free_shipping_desc":"You will bear the shipping cost for orders over a certain amount. Turn this on and off in settings.",

    "offer_free_shipping_min_order":"Min. order amount:",
    "offer_free_shipping_min_order_desc":"Free shipping automatically offered when total order exceeds this amount",
            
    "local_delivery_rates":"LOCAL DELIVERY RATES",
    "local_delivery_rates_markup":"Do you want to mark up Yezza Shipping rates for local delivery orders?",
    "local_delivery_rates_markup_desc1":"Charge customers additional markup amounts on top of Yezza Shipping rates.",
    "local_delivery_rates_markup_desc2":"Example: Markup amount = RM 4.00",
    "local_delivery_rates_markup_time":"time rates = RM 5.00",
    "local_delivery_rates_markup_fee_charge":"fee charge = RM 12.00 ",

                  
    "store_pickup":"STORE PICKUP",
    "store_pickup_desc1":"Add instructions for store pickup customers",
    "store_pickup_desc2":"Help customers to pickup orders at your location by providing clear instructions.",

    "store_pickup_instruction":"Pickup instructions",
    "store_pickup_can_pay":"Can store pickup customers pay at shop?",
    "store_pickup_can_pay_desc":"Allow customers to pay for their order upon pick up at your location.",
    "great_all_set":"Great, you’re all set!",
    "finish_yezza_store_setup_desc1":"You can now start arranging courier and local delivery shipments with Yezza Shipping.",
    "finish_yezza_store_setup_desc2":"You can now start arranging courier shipments with Yezza Shipping.",
    "finish_yezza_store_setup_desc3":"You can now start arranging local delivery shipments with Yezza Shipping.",
    "finish_yezza_store_setup_desc4":"Your store pickup settings are now all in one convenient place.",
                
    "finish_yezza_store_setup_desc5":"Make sure to check any updates made to your settings in the following locations:",
    "finish_yezza_store_setup_desc6":"1. Advanced Setup -> Shipping and Delivery",
    "finish_yezza_store_setup_desc7":"2. Whatsapp Form -> Advance Shipping Setting",
    "finish_yezza_store_setup_desc8":"3. Yezza Store -> Manage Shipping Settings",
                
    "return_to_shipping":"Return to shipping",
                
        
    "leaving_yezza_shipping_setup":"Leaving Yezza Shipping setup?",
    "progress_is_saved":"We’ll save your progress so you can come back and finish later.",

    "courier_shipping_title":"Courier Shipping",
    "courier_shipping_title_desc":"e.g. Poslaju, J&T Express, Pgeon",
    "local_delivery_title":"Local delivery by on-demang services",
    "local_delivery_title_desc":"e.g. Lalamove, Grab, Borzo,",
    "pickup_title":"Pick up at store",
    "pickup_title_desc":"Customer picks up their order at your location"


    
  },
   "id": {
     "update_company": "Update Detail Perusahaan",
    "company_logo": "Logo perusahaan",
    "company_name": {
      "label": "Nama Perusahaan",
      "placeholder": ""
    },
    "company_phone": {
      "label": "Nomor Telepon",
      "placeholder": ""
    },
    "registration_number": {
      "label": "No Registrasi Perusahaan",
      "placeholder": ""
    },
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    },
    "tax_rate": {
      "label": "Persentase Pajak",
      "placeholder": ""
    },
    "cancel": "Batal",
    "update": "Simpan",
    "setup_yezza" : "Setup Yezza Shipping",
    "fulfill_order" : "Memenuhi pesanan pelanggan tanpa meninggalkan Yezza",
    "please_note" : " ",
                            
    "how_to_fulfill_order":"Bagaimana cara kamu mengirimkan pesanan pelanggan?",
    "select_all":"Pilih semua yang kamu gunakan.",

    "your_location" : "Dimana lokasi kamu?",
    "where_courier_collect":"Tuliskan alamat toko kamu saat ini ",

    "same_location_store_pickup":"Lokasi pick-up di Toko juga sama",
                  
    "store_pickup_address":"Lokasi pick-up di Toko",
    "location_coordinate":"Tentukan titik lokasi Toko kamu",
    "drag_pin_point":"Geser ikon '..' untuk menyesuaikan lokasi toko kamu",

    "courier_shipping":"EKSPEDISI",
    "courier_services":"Ekspedisi apa saja yang akan kamu gunakan?",
    "courier_option":"Pilihlah ekspedisi yang akan kamu gunakan untuk pengiriman Toko kamu",

    "courier_not_available":"Tidak ditemukan di kawasan kamu",
                
    "select_prefered_method":"Select prefered handover method:",
    "local_delivery":"Instant Kurir",
    "choose_local_delivery":"Instant Kurir apa saja yang akan kamu gunakan?",
    "local_delivery_option":"Pilihlah Instant kurir yang akan kamu gunakan untuk pengiriman Toko kamu",

    "select_vehicles":"Select vehicle(s) you will use:",
    "keep_shipping_zone":"Do you want to keep your shipping zones?",
    "shipping_zone_necessary":"Shipping zones are necessary if you:",
    "organize_manual_rates":"Need to organize manual rates by delivery area",
    "provide_COD_option":"Want to provide customers with COD payment option",
    "hire_own_rider":"Hire your own rider with specified rates",

    "keep_shipping_zone_yes":"Yes, keep my shipping zones",
    "keep_shipping_zone_yes_desc":"We’ll replace any shipping integrations with Yezza Shipping. No changes will be made to your Manual Delivery rates.",
                
    "keep_shipping_zone_no":"No, I don’t need shipping zones",
    "keep_shipping_zone_no_desc":"Shipping rates at customer checkout will be auto-calculated by Yezza Shipping.",
                
    "what_are_yezza_shipping_rates":"What are Yezza Shipping rates?",
    "get_real_time_rates":"Your customers will get real-time calculated rates from our delivery partners at checkout based on recipient address and package weight. You can even markup these prices to cover any extra costs.",
          
    "courier_shipping_rates":"Ongkos Kirim Ekspedisi",
    "markup_courier_shipping_rates":"Apakah kamu ingin menaikkan biaya pengiriman untuk pesanan menggunakan ekspedisi?",
    "markup_courier_shipping_rates_desc1":"Menaikkan biaya pengiriman tambahan kepada pelanggan diluar tarif Yezza Shipping",
    "markup_courier_shipping_rates_desc2":"Contoh: Menaikkan Biaya = Rp. 3.500",
    "markup_courier_shipping_rates_time":"Tarif real-time = Rp. 6.500",
    "markup_courier_shipping_rates_fee_charge":"Tarif Charge =Rp. 9.000 ",

                  
    "markup_amount":"Menaikkan Biaya:",
    "markup_amount_desc":"Jumlah ini akan ditambahkan ke tarif real-time yang dihitung",
                  
    "offer_free_shipping":"Apakah kamu ingin menanggung ongkos kirim pelanggan?",
    "offer_free_shipping_desc":"Kamu akan menanggung ongkos kirim untuk pesanan pada jumlah tertentu. Kamu dapat aktifkan dan nonaktifkan di Pengaturan",

    "offer_free_shipping_min_order":"Min. order amount:",
    "offer_free_shipping_min_order_desc":"Free shipping automatically offered when total order exceeds this amount",
            
    "local_delivery_rates":"Ongkos Kirim Instant Kurir",
    "local_delivery_rates_markup":"Apakah kamu ingin menaikkan biaya pengiriman untuk pesanan menggunakan Instant Kurir?",
    "local_delivery_rates_markup_desc1":"Menaikkan biaya pengiriman tambahan kepada pelanggan diluar tarif Yezza Shipping",
    "local_delivery_rates_markup_desc2":"Contoh: Menaikkan Biaya = Rp. 3.500",
    "local_delivery_rates_markup_time":"Tarif real-time = Rp. 6.500",
    "local_delivery_rates_markup_fee_charge":"Tarif Charge =Rp. 9.000 ",

                  
    "store_pickup":"AMBIL DI TOKO",
    "store_pickup_desc1":"Tambahkan informasi untuk pelanggan ",
    "store_pickup_desc2":"Hal ini dapat membantu pelanggan untuk pick-up pesanan di lokasi kamu dengan lebih mudah",

    "store_pickup_instruction":"Informasi pick-up pesanan",
    "store_pickup_can_pay":"Bisakah pelanggan pickup dan membayar di Toko?",
    "store_pickup_can_pay_desc":"Memungkinkan pelanggan untuk membayar pesanan saat mengambil pesanan di lokasi kamu",
    "great_all_set":"Bagus! Kamu sudah siap!",
    "finish_yezza_store_setup_desc1":"Sekarang kamu dapat mulai mengatur pengiriman  dengan ekspedisi dan instant kurir menggunakan Yezza Shipping",
    "finish_yezza_store_setup_desc2":"Sekarang kamu dapat mulai mengatur pengiriman  dengan ekspedisi menggunakan Yezza Shipping",
    "finish_yezza_store_setup_desc3":"Sekarang kamu dapat mulai mengatur pengiriman  dengan instant kurir menggunakan Yezza Shipping",
    "finish_yezza_store_setup_desc4":"Sekarang pelanggan bisa pick-up pesanan di Toko Kamu",
                
    "finish_yezza_store_setup_desc5":"Pastikan untuk memeriksa setiap pembaruan yang dibuat untuk kamu pada pengaturan di lokasi berikut:",
    "finish_yezza_store_setup_desc6":"1. Advanced Setup -> Shipping and Delivery",
    "finish_yezza_store_setup_desc7":"2. Whatsapp Form -> Advance Shipping Setting",
    "finish_yezza_store_setup_desc8":"3. Yezza Store -> Manage Shipping Settings",
                
    "return_to_shipping":"Kembali ke Pengiriman",
                
        
    "leaving_yezza_shipping_setup":"Tinggalkan Setup Yezza Shipping?",
    "progress_is_saved":"We’ll save your progress so you can come back and finish later.",

    "courier_shipping_title":"Ekspedisi",
    "courier_shipping_title_desc":"e.g. Antaraja, J&T Express",
    "local_delivery_title":"Instant Kurir",
    "local_delivery_title_desc":"e.g. GoSend, GrabExpress",
    "pickup_title":"Ambil di Toko",
    "pickup_title_desc":"Pelanggan akan pick-up pesanan di lokasi kamu"

  }
}
</i18n>
